import React from "react";
import { useSelector } from "react-redux";
import { Button, Card } from "@tecma/ds";
import { useTranslation } from "@tecma/i18n";
import { ContactUsMethods } from "types";
import { applicationStateSelectors } from "store/slices/applicationState/selectors";

import { CONTACT_US_CONFIG } from "../../constants";
import "./contact-us-card.scss";

interface ContactUsCardProps {
  method: ContactUsMethods;
}

const ContactUsCard: React.FC<ContactUsCardProps> = ({ method }) => {
  const { t } = useTranslation();
  const contacts = useSelector(applicationStateSelectors.contacts);

  const handleOnClick = () => {
    const contactProps = CONTACT_US_CONFIG[method] ?? null;
    if (typeof contactProps?.link === "function") {
      window.open(contactProps.link(contacts[method]), "_self");
    }
  };
  if (!contacts[method]) return null;
  return (
    <Card className='contact-us-card'>
      <Card.Header className='contact-us-card__header'>
        <span className='contact-us-card__title'>
          {t(`contact-us-modal.${method}.title`)}
        </span>
      </Card.Header>
      <Card.Content>
        <span className='contact-us-card__description'>
          {t(`contact-us-modal.${method}.description`)}
        </span>
      </Card.Content>
      <Card.Footer>
        <Button
          iconName={CONTACT_US_CONFIG[method]?.iconName}
          className='contact-us-card__button'
          rounded
          fluid
          outlined={method === "phone"}
          onClick={handleOnClick}
        >
          {t(`contact-us-modal.${method}.title`, {
            method: contacts[method],
          })}
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default ContactUsCard;
